import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend"; // 동적 리소스 로드를 위한 백엔드
import LanguageDetector from "i18next-browser-languagedetector"; // 브라우저 언어 감지

// 정적 리소스 (미리 불러오기)
import translationEn from "./locales/en/trans.en.json";
import translationKo from "./locales/ko/trans.ko.json";

// 미리 불러올 정적 리소스 설정
const resources = {
  en: {
    translation: translationEn,
  },
  ko: {
    translation: translationKo,
  },
};

// 언어 감지 옵션 설정
const languageDetector = {
  order: ["subdomain", "querystring", "cookie", "localStorage", "navigator", "htmlTag", "path"], // 서브도메인 감지를 우선으로 함
  caches: ["localStorage", "cookie"], // 언어를 캐시할 방법
  lookupSubdomain: false, // 서브도메인 자동 감지 비활성화
  // 도메인에 따라 언어를 설정
  lookup: () => {
    const hostname = window.location.hostname;

    if (hostname.includes("en-cp")) {
      return "en"; // 영어 서브도메인
    } else {
      return "ko"; // 한국어 서브도메인
    }
  },
};

i18n
  .use(Backend) // 백엔드를 통해 동적 리소스를 불러옴
  .use(LanguageDetector) // 브라우저 언어 감지
  .use(initReactI18next) // React와 통합
  .init({
    resources, // 미리 불러온 정적 리소스
    fallbackLng: "ko", // 기본 언어 설정
    debug: process.env.NODE_ENV === "development", // 개발 환경에서 디버깅
    interpolation: {
      escapeValue: false, // React는 자동으로 XSS 보호를 처리함
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json", // 동적 리소스 파일 경로
    },
    detection: languageDetector, // 위에서 설정한 언어 감지 옵션 사용
  });

// 브라우저 캐시를 초기화하고 강제로 언어 변경 (선택적 사용)
i18n.changeLanguage(languageDetector.lookup()); // 언어 강제 설정

export default i18n;
